import { IOptionsForTags } from "@interfaces/tag.interface";

export const FIRST_FIVE_TAGS = 5;

export const TagsTypes = {
  MEETING: [
    "companies",
    "people",
    "deals",
    "ai_notes",
    "users",
    "documents",
    "themes",
    "threads",
    "folders",
    "labels",
    "funds",
    "opportunities",
  ],
  MEETING_TOPICS: ["companies", "deals"],
  // Data Objects fallback set; the allowed types come per-field via `tagTypes`.
  MERIDIAN_RECORD: ["deals", "companies", "people"],
  GLOBAL_SEARCH: [
    "companies",
    "people",
    "deals",
    "ai_notes",
    "documents",
    "themes",
    "threads",
    "labels",
    "ic_meetings",
    "prm_meetings",
    "regular_meetings",
    "folders",
  ],
  NOTES: [
    "companies",
    "people",
    "deals",
    "ic_meetings",
    "prm_meetings",
    "regular_meetings",
    "documents",
    "themes",
    "users",
    "threads",
    "folders",
    "funds",
    "opportunities",
  ],
  EMAIL_THREADS: [
    "companies",
    "people",
    "deals",
    "regular_meetings",
    "documents",
    "ai_notes",
    "users",
    "funds",
    "opportunities",
  ],
  SOURCING_THEMES: ["themes"],
};

export const INITIAL_TAGS_VALUE = {
  companies: [],
  people: [],
  deals: [],
  meetings: [],
  documents: [],
  ai_notes: [],
  themes: [],
  users: [],
  labels: [],
  funds: [],
  opportunities: [],
};

export const EXISTING_TAGS_ORDER = [
  "companies.company",
  "people.person",
  "deals.deal",
  "meetings.meeting",
  "documents.documentfile",
  "documents.folder",
  "notes.ainote",
  "sourcing.theme",
  "accounts.user",
  "emails.thread",
  "fundraising.fund",
  "fundraising.opportunity",
];

export const DESIRED_ORDER: Array<keyof IOptionsForTags> = [
  "deals",
  "companies",
  "people",
  "meetings",
  "documents",
  "folders",
  "ai_notes",
  "themes",
  "threads",
  "users",
  "funds",
  "opportunities",
];

export const CUSTOM_SECTION_TITLES: Record<string, string> = {
  ai_notes: "Notes",
  users: "Team Members",
};

export const SUGGESTED_TAG_GROUPS: Array<keyof IOptionsForTags> = ["people", "deals"];
